/*
 * @Descripttion: store
 * @FilePath: /mall-wap-vue/src/store/index.js
 * @Author: 张兴业
 * @Date: 2020-09-24 10:19:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-11-18 15:16:07
 */
import Vue from "vue";
import Vuex from "vuex";
import login from "./modules/login";
import home from "./modules/home";
import mine from "./modules/mine";
import product from "./modules/product";
import cart from "./modules/cart";
import order from "./modules/order";
import load from "./modules/load";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    login,
    home,
    mine,
    product,
    cart,
    order,
    load
  },
  getters
});
